import { Popover } from 'antd';
import * as cookie from 'cookie';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fixCurrentPage } from '../../common/analytics/helpers/pageHelper';
import config from '../../common/config';
import commonResource from '../../locales/th/common.json';
import AccountIcon from './AccountIcon';
import {
  AccountTextWrapper,
  DesktopAccountWrapper,
  PopoverWrapper,
  UserEmail,
} from './DesktopAccount.style';
import AccountIconIA from './AccountIconIA';
import {
  trackRegister,
  trackLogin,
} from '../../common/analytics/analyticsTracker';

function DesktopAccount() {
  const [loggedIn, setLoggedIn] = useState(false);
  const islogin = useSelector((state) =>
    state.common !== undefined ? state.common.islogin : false,
  );
  const email = useSelector((state) =>
    state.common !== undefined ? state.common.loginEmail : '',
  );
  const displayName = useSelector((state) =>
    state.common !== undefined ? state.common.displayName : '',
  );
  const currentPage = useSelector((state) =>
    state.common !== undefined ? state.common.currentPage : '',
  );
  const userInfo = useSelector((state) =>
    state.common !== undefined ? state.common.user : {},
  );
  const sourceType = fixCurrentPage(currentPage);

  useEffect(() => {
    setLoggedIn(islogin);
  }, [islogin]);

  const handleLogout = () => {
    setLoggedIn(false);

    document.cookie = cookie.serialize(
      'tol-last-visited-page',
      window.location.href,
      {
        httpOnly: true,
        sameSite: 'lax',
        secure: true,
        maxAge: 7 * 24 * 60 * 60,
        domain: `${config.cookieDomain}`,
        path: '/',
        encode: (s) => s,
      },
    );
  };

  const renderPopoverContent = () => {
    const logoutUrl = `${config.logoutUrl}`;
    const myProfileText = commonResource.account.myprofile;
    const logoutText = commonResource.account.logout;

    return (
      <PopoverWrapper>
        <UserEmail data-test="user-email">{email}</UserEmail>
        <div>
          <AccountIcon />
          <a href="/profile" data-test="profile-link">
            {myProfileText}
          </a>
        </div>
        <a
          className="logout-btn"
          href={logoutUrl}
          onClick={() => {
            handleLogout();
          }}
        >
          {logoutText}
        </a>
      </PopoverWrapper>
    );
  };

  const renderAccountBeforeLogin = () => {
    const signupUrl = `${config.signupUrl}`;
    const loginUrl = `${config.loginUrl}`;
    const signUpText = commonResource.account.signUp;
    const loginText = commonResource.account.login;

    return (
      <>
        <a
          href={signupUrl}
          data-test="signup-link"
          onClick={() => {
            saveCurrentLocation();
            trackRegister(userInfo, sourceType);
          }}
        >
          {signUpText}
        </a>
        <a
          href={loginUrl}
          data-test="login-link"
          onClick={() => {
            saveCurrentLocation();
            trackLogin(userInfo, sourceType);
          }}
        >
          {loginText}
        </a>
      </>
    );
  };

  const saveCurrentLocation = () => {
    document.cookie = cookie.serialize(
      'tol-last-visited-page',
      window.location.pathname,
      {
        httpOnly: true,
        sameSite: 'lax',
        secure: true,
        maxAge: 7 * 24 * 60 * 60,
        domain: `${config.cookieDomain}`,
        path: '/',
        encode: (s) => s,
      },
    );
  };

  const renderAccountAfterLogin = () => {
    return (
      <Popover
        placement="bottom"
        content={renderPopoverContent()}
        trigger="click"
      >
        <AccountTextWrapper
          className="desktop-account-text"
          data-test="desktop-account-text"
        >
          <span className="icon">
            <AccountIconIA />
          </span>
          <span>{displayName}</span>
        </AccountTextWrapper>
      </Popover>
    );
  };

  return (
    <DesktopAccountWrapper className="desktop-account">
      {loggedIn ? renderAccountAfterLogin() : renderAccountBeforeLogin()}
    </DesktopAccountWrapper>
  );
}

export default DesktopAccount;
